<template>

	<div>

	  	<div v-if="step == 1" id="wrapper-upload-documents">

	  		<div v-if="!embedded">

		  		<h5>Bilder und Dokumente übertragen</h5>

				<p class="sm-infotext" style="font-size:14px;margin:0;">
					Bitte erfassen und übertragen Sie uns anschließend den Fahrzeugschein und die Bilder zum Schaden.<br />
					Hinweis: Wenn Sie eine langsame Internetverbindung haben, erstellen Sie die Fotos vorab und wählen diese danach aus Ihrem Fotoalbum aus.
				</p>

			  	<div class="connection-info mb-4">
					<vue-identify-network>
					  <template #slow>
					    <span class="connection-dot dot-yellow"></span> Ihre Internetverbindung: langsam
					  </template>
					  <template #fast>
					    <span class="connection-dot dot-green"></span> Ihre Internetverbindung: schnell
					  </template>
					</vue-identify-network>
				</div>

			</div>

			<!-- Upload Fahrzeugschein-->
			<div class="mb-4">
				<!--<label class="form-label">Fahrzeugschein:</label>-->
				<div class="d-sm-flex mb-3">
					<!--<a class="d-flex align-items-center btn-add-vehicle" @click="onToggleRegistrationBox()" v-if="formdata.files_registration.length == 0">
						<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon"><path d="M24 44.6899C35.0457 44.6899 44 35.7356 44 24.6899C44 13.6442 35.0457 4.68994 24 4.68994C12.9543 4.68994 4 13.6442 4 24.6899C4 35.7356 12.9543 44.6899 24 44.6899Z" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M24 16.6899V32.6899" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M16 24.6899H32" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path></svg>
						<span class="ml-2">Fahrzeugschein erfassen</span>
					</a>-->
					<div class="calendar-slot-excerpt d-flex justify-content-start align-items-center" style="margin:0" @click="onToggleRegistrationBox()">
						<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg" class="documents-toggle">
							<path d="M24 44.6899C35.0457 44.6899 44 35.7356 44 24.6899C44 13.6442 35.0457 4.68994 24 4.68994C12.9543 4.68994 4 13.6442 4 24.6899C4 35.7356 12.9543 44.6899 24 44.6899Z" stroke="#219653" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M24 16.6899V32.6899" stroke="#219653" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" v-if="!showRegistrationBox" />
							<path d="M16 24.6899H32" stroke="#219653" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
						<div>
							<div class="label-small">Fahrzeugschein<span v-if="content.setting_singlejob_registration_document_required" class="text-danger">*</span>:</div>
							<div class="d-flex justify-content-start align-items-center">
								<div v-if="formdata.files_registration.length > 0">
									Sie haben <span class="highlighted">{{ formdata.files_registration.length }}</span> Fahrzeugschein erfasst.
								</div>
								<div v-else>
									Sie haben noch keinen Fahrzeugschein erfasst.
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row no-gutters mb-2" v-show="showRegistrationBox">
				    <div class="col-sm-5">
				    	<div class="example-image" @click="openDropzoneDetail('dropzone_files_registration')"><img src="/images/ksr/zulassungsbescheinigung-sample.jpg" class="img-fluid" alt="Zulassungsbescheinigung"></div>
				    </div>
				    <div class="col-sm-7 pl-2 dropzone-wrapper-registration">
						<vue-dropzone ref="myVueDropzone_files_registration" id="dropzone_files_registration" :options="dropzoneOptionsMultiple" @vdropzone-file-added="fileAdded" @vdropzone-sending-multiple="sendingFiles_registration" @vdropzone-success-multiple="successFiles_registration" @vdropzone-removed-file="removeFile"></vue-dropzone>
						<div class="allowed-filetypes">Erlaubte Dateitypen: .jpg, .png, .pdf, maximale Dateigröße 50MB</div>
					</div>
				</div>
			</div>
            <div id="invalid-registration-required" class="d-block invalid-feedback mb-4" style="margin-top:-10px;" v-if="formdata_errors.includes('registration_document')">
            	Bitte erfassen Sie Ihren Fahrzeugschein.
            </div>

			<!-- Upload Schadenbilder -->
			<div class="mb-4">
				<!--<label class="form-label">Schadensbilder:</label>-->
				<KSRDamageRecording ref="refDamageRecording" :kit="kit" :storeId="storeId" :jobId="jobId" :damageToken="damageToken" :hideTitle="true" :singleUpload="true" :required="false" @setdamage="setDamage" @damageWindowOpen="isDamageWindowOpen" />
				<div id="invalid-damage" class="hidden invalid-feedback">
	            	Es wurden keine Schadenbilder erfasst.
	            </div>
			</div>
			<!-- Upload sonstige Dokumente -->

			<div v-if="!embedded">

				<!-- Upload sonstige Dokumente -->
				<div class="mb-4">
					<!--<label class="form-label">Sonstige Dokumente:</label>-->
					<div class="d-sm-flex mb-3">
						<!--<a class="d-flex align-items-center btn-add-vehicle" @click="onToggleMiscBox()" v-if="formdata.files_misc.length == 0">
							<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-icon"><path d="M24 44.6899C35.0457 44.6899 44 35.7356 44 24.6899C44 13.6442 35.0457 4.68994 24 4.68994C12.9543 4.68994 4 13.6442 4 24.6899C4 35.7356 12.9543 44.6899 24 44.6899Z" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M24 16.6899V32.6899" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M16 24.6899H32" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path></svg>
							<span class="ml-2">Sonstige Dokumente</span>
						</a>-->
						<div class="calendar-slot-excerpt d-flex justify-content-start align-items-center" style="margin:0" @click="onToggleMiscBox()">
							<svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg" class="documents-toggle">
								<path d="M24 44.6899C35.0457 44.6899 44 35.7356 44 24.6899C44 13.6442 35.0457 4.68994 24 4.68994C12.9543 4.68994 4 13.6442 4 24.6899C4 35.7356 12.9543 44.6899 24 44.6899Z" stroke="#219653" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M24 16.6899V32.6899" stroke="#219653" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" v-if="!showMiscBox" />
								<path d="M16 24.6899H32" stroke="#219653" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<div>
								<div class="label-small">Sonstige Dokumente:</div>
								<div class="d-flex justify-content-between align-items-center">
									<div v-if="formdata.files_misc.length > 0">Sie haben <span class="highlighted">{{ formdata.files_misc.length }}</span> <span v-if="formdata.files_misc.length > 1">Dokumente</span><span v-else>Dokument</span> erfasst.</div>
									<div v-else>Sie haben noch keine Dokumente erfasst.</div>
								</div>
							</div>
						</div>
					</div>
					<div class="row no-gutters mb-2" v-show="showMiscBox">
					    <div class="col-sm-12 dropzone-wrapper-misc">
							<vue-dropzone ref="myVueDropzone_files_misc" id="dropzone_files_misc" :options="dropzoneOptionsMultiple" @vdropzone-file-added="fileAdded" @vdropzone-sending-multiple="sendingFiles_misc" @vdropzone-success-multiple="successFiles_misc" @vdropzone-removed-file="removeFile"></vue-dropzone>
							<button class="add-more-images" @click="openDropzoneDetail('dropzone_files_misc')">+ weitere Bilder hinzufügen</button>
							<div class="allowed-filetypes">Erlaubte Dateitypen: .jpg, .png, .pdf, maximale Dateigröße 50MB</div>
						</div>
					</div>
				</div>

			</div>

			<div class="form-group" v-if="!embedded">
                <label class="form-label" for="message">Ihre Nachricht an die Werkstatt (optional):</label>
                <textarea name="message" id="message" v-model="formdata.message" class="form-control"></textarea>
            </div>

			<div class="text-center" v-if="!embedded">
	            <button class="btn btn-primary my-3 mr-1" v-if="" @click="onUploadDocuments()" :disabled="loading || hideSubmitButton || !documentsReady" :class="{ disabled: loading || hideSubmitButton || !documentsReady }">
	            <div class="spinner-border text-white mr-2" role="status" v-if="loading">
	                <span class="sr-only">Loading...</span>
	            </div>
	            Erfasste Bilder & Dokumente übertragen</button>
	        </div>

	        <div class="sm-infotext mb-1 text-danger" v-if="content.setting_singlejob_registration_document_required">* Erforderliche Dokumente</div>
	        <div class="sm-infotext">Bitte beachten Sie: Die Übertragung Ihrer Schadensmeldung kann erst erfolgen, wenn die Erfassung der Schadenbilder vollständig abgeschlossen ist. Die Dauer der Übertragung kann je nach Bildgröße und Ihrer Internetverbindung variieren und möglicherweise etwas Zeit in Anspruch nehmen.</div>

		</div>

		<div v-if="step == 2">
			<h2 class="mb-4">Vielen Dank</h2>
	        <p class="mb-4">Wir haben Ihre Dokumente erhalten</p>
	        <div class="mb-1">
	            <a href="javascript:void(0)" @click="reload()">Zurück zur Übersicht</a>
	        </div>
		</div>

	</div>

</template>

<script>
import KSRDamageRecording from "./KSRDamageRecording";
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import { VueIdentifyNetwork } from 'vue-identify-network';

export default {

	components: { KSRDamageRecording, vueDropzone: vue2Dropzone, VueIdentifyNetwork },
    name: "KSRUploadDocuments",
    data() {
        return {
        	step: 1,
        	dropzoneOptionsMultiple: {
				url: '/api/ksr/upload/documents/temp',
			    paramName: function(n) {
                    return "file[]";
                },
				maxFilesize: 50,
                thumbnailWidth: 250,
                thumbnailHeight: 140,
				uploadMultiple: true,
				parallelUploads: 1,
				acceptedFiles: 'image/*,application/pdf',
				dictDefaultMessage: "Dateien hier ablegen oder Fotos machen",
				dictRemoveFile: "Löschen",
				dictCancelUpload: "Abbrechen",
				dictCancelUploadConfirmation: "Sicher",
				addRemoveLinks: true,
			},
			formdata: {
				jobId: '',
				storeId: '',
	            files_registration: [],
	            files_misc: [],
	            message: '',
	            damageId: false
	        },
            formdata_errors: [],
            hideSubmitButton: false,
            loading: false,
            showRegistrationBox: false,
            showMiscBox: false
        }
    },
    mounted() {
    	this.formdata.jobId = this.jobId;
    	this.formdata.storeId = this.storeId;
    	setTimeout(function() {
			var element = document.querySelector("#booking-container");
			if(element)
    			element.scrollIntoView();
    	}, 200);
    },
	computed: {
	    documentsReady: function () {
			let documents_ready = false;
			if(this.formdata.files_registration.length > 0) { documents_ready = true; }
			if(this.formdata.files_misc.length > 0) { documents_ready = true; }
			if(this.formdata.damageId) { documents_ready = true; }
			if(this.content.setting_singlejob_registration_document_required && this.formdata.files_registration.length == 0) { documents_ready = false; }
			return documents_ready;
	    },
	    /*showRegistrationBox: function() {
	    	return files_registration.length > 0;
	    }*/
	},
    methods: {
    	resetChild() {
    		this.$refs.refDamageRecording.refreshDamages();
    	},
    	fileAdded(file) {
            // Construct your file object to render in the UI
        },
    	sendingFiles_registration(files, xhr, formData) {
        	let uuids = [];
        	for(var k = 0; k < files.length; k++) {
        		uuids.push(files[k].upload.uuid);
        	}
        	formData.append('uuids', uuids);
            formData.append('type', 'registration');
        },
        successFiles_registration(files, response) {
        	for(var k = 0; k < response.length; k++) {
            	this.formdata.files_registration.push(response[k]);
            	this.showRegistrationBox = false;
        	}
        },
		sendingFiles_misc(files, xhr, formData) {
        	let uuids = [];
        	for(var k = 0; k < files.length; k++) {
        		uuids.push(files[k].upload.uuid);
        	}
        	formData.append('uuids', uuids);
            formData.append('type', 'misc');
        },
        successFiles_misc(files, response) {
        	for(var k = 0; k < response.length; k++) {
            	this.formdata.files_misc.push(response[k]);
            	this.showMiscBox = false;
        	}
        },
		removeFile(file, error, xhr) {
        	if(file.manuallyAdded) {
        		// edit manually added files when editing
	        	for(var k = 0; k < this.formdata.files_registration.length; k++) {
	        		if(this.formdata.files_registration[k] == file.name) { this.formdata.files_registration.splice(k, 1); }
	        	}
	        	for(var k = 0; k < this.formdata.files_misc.length; k++) {
	        		if(this.formdata.files_misc[k] == file.name) { this.formdata.files_misc.splice(k, 1); }
	        	}
        	}
        	else {
        		// new files
        		let uuidArr = file.upload.uuid.split('-');
        		let uuidShort = uuidArr[uuidArr.length - 1];
	        	for(var k = 0; k < this.formdata.files_registration.length; k++) {
	        		if(this.formdata.files_registration[k].includes(uuidShort)) { this.formdata.files_registration.splice(k, 1); }
	        	}
	        	for(var k = 0; k < this.formdata.files_misc.length; k++) {
	        		if(this.formdata.files_misc[k].includes(uuidShort)) { this.formdata.files_misc.splice(k, 1); }
	        	}

        	}
        },
        setDamage(damageId) {
        	if(damageId)
            	this.formdata.damageId = damageId;
        },
        onUploadDocuments() {

        	this.loading = true;

    		var data = {
        		formdata: this.formdata
   			}

   			console.log(this.formdata.files_registration.length);
   			if(this.content.setting_singlejob_registration_document_required && this.formdata.files_registration.length == 0) {
   				this.formdata_errors.push('registration_document');
   				this.loading = false;
   				return;
   			}

   			var _this = this;

        	axios.post('/api/ksr/upload/documents/send?identityToken='+this.kit, data)
		        .then((response) => {
		        	console.log(response.data.status);
		        	_this.loading = false;
		        	if(response.data.status == 'success') {
		        		_this.step = 2;
		        	}
		            //this.vehicles = response.data.value;
		            /*if(response.data.status == 'exists') {
		            	_this.message = 'Fahrzeug existiert bereits.';
		            }
		            if(response.data.status == 'created') {
		            	_this.message = 'Fahrzeug wurde erfolgreich angelegt.';
		            	_this.vehicles.push(response.data.vehicle);
		            }
		            this.loading = false;*/
		        });
        },
        reload() {
            location.reload();
        },
        isDamageWindowOpen(value) {
        	this.hideSubmitButton = value;
        },
        onToggleRegistrationBox() {
        	this.showRegistrationBox = !this.showRegistrationBox;
        	/*this.editDamage = false;
        	if(this.addNewDamage && !this.singleUpload) {
        		setTimeout(function() {
        			var element = document.querySelector("#form-new-damage");
        			if(element)
            			element.scrollIntoView();
				}, 200);
        	}
        	else {
        		setTimeout(function() {
        			var element = document.querySelector("#wrapper-select-damage");
        			if(element)
            			element.scrollIntoView();
            	}, 200);
        	}
        	// emit event to parent
        	if(this.addNewDamage == true) { this.$emit('damageWindowOpen', true) }
        	else { this.$emit('damageWindowOpen', false)  }*/
        },
        onToggleEditRegistrationBox() {

        },
        onToggleMiscBox() {
        	this.showMiscBox = !this.showMiscBox;
        	/*this.editDamage = false;
        	if(this.addNewDamage && !this.singleUpload) {
        		setTimeout(function() {
        			var element = document.querySelector("#form-new-damage");
        			if(element)
            			element.scrollIntoView();
				}, 200);
        	}
        	else {
        		setTimeout(function() {
        			var element = document.querySelector("#wrapper-select-damage");
        			if(element)
            			element.scrollIntoView();
            	}, 200);
        	}
        	// emit event to parent
        	if(this.addNewDamage == true) { this.$emit('damageWindowOpen', true) }
        	else { this.$emit('damageWindowOpen', false)  }*/
        },
        /*onToggleEditDamageBox() {
        	this.editDamage = !this.editDamage;
        	this.addNewDamage = false;
        	// emit event to parent
        	if(this.editDamage == true) { this.$emit('damageWindowOpen', true) }
        	else { this.$emit('damageWindowOpen', false)  }
        }*/
        openDropzoneDetail(id) {
        	//this.myVueDropzone_files_detail_1.dropzone().clickableElements[0].click();
        	document.getElementById(id).click();
        }
    },
    props: ['kit', 'storeId', 'jobId', 'damageToken', 'hideTitle', 'required', 'embedded', 'content']
};
</script>

<style>

</style>
